import { useQuery } from "react-query";
import { fetchCoinHistory } from "./api";
import ApexChart from 'react-apexcharts';
import {useRecoilValue} from 'recoil';
import {isDarkAtom} from '../atoms'

interface IHistorical {
  time_open: string;
  time_close: string;
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
  market_cap: number;
}

interface ChartProps {
  coinId: string;
}

const Chart = ({coinId}: ChartProps) => {
  const {isLoading, data} = useQuery<IHistorical[]>(['ohlcv', coinId], () => fetchCoinHistory(coinId));
  const isDark = useRecoilValue(isDarkAtom);

  return(
    <div>{isLoading ? 
      ('Loading chart...') : (
      <ApexChart 
        type="line" 
        series={[
          {
            name: 'Price',
            data: data?.map((price) => price.close) as number[],
          },
        ]}
        options={{
          theme: {
            mode: isDark ? 'dark' : 'light',
          },
          chart: {
            height: 500,
            width: 500,
            toolbar: {
              show: false,
            },
            background: 'transparent',
          },
          grid: {
            show: false,
          },
          stroke: {
            curve: 'smooth',
            width: 5,
          },
          yaxis: {
            show: false,
          },
          xaxis: {
            axisBorder: {show: false,},
            axisTicks: {show: false,},
            labels: {show: false,},
          },
        }} />
    )}</div>
  );
};

export default Chart;